import { render, staticRenderFns } from "./korToMas.vue?vue&type=template&id=5b46054c&scoped=true&"
import script from "./korToMas.vue?vue&type=script&lang=js&"
export * from "./korToMas.vue?vue&type=script&lang=js&"
import style0 from "./korToMas.vue?vue&type=style&index=0&id=5b46054c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b46054c",
  null
  
)

export default component.exports